import type { CSSProperties } from 'react';
import type { Slide } from '../types/slide';
import { CANVAS, FONT_STACKS } from './brand';

/** Full-size (1280×720) slide surface: background color/photo and the template body font. */
export function slideSurfaceStyle(slide: Slide): CSSProperties {
  return {
    position: 'relative',
    overflow: 'hidden',
    width: CANVAS.width,
    height: CANVAS.height,
    backgroundColor: slide.background,
    backgroundImage: slide.backgroundImage ? `url(${slide.backgroundImage})` : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    fontFamily: FONT_STACKS.body,
  };
}
